document.addEventListener("DOMContentLoaded", () => {
  console.log("after-login.js loaded");
  const loginForm = document.querySelector('form[action="/account/login"]');

  // if (loginForm) {
  //   loginForm.addEventListener("submit", async (e) => {
  //     //// e.preventDefault();

  //     let token =
  //       Math.random().toString(36).substring(2, 15) +
  //       Math.random().toString(36).substring(2, 15);
  //     //store the token in the session storage
  //     localStorage.setItem("sessionToken", token);

  //     return true;
  //   });
  // }
});
